import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner(props) {

  return (
    <div>
    <div className="title-long">
      <div
      style = {{
          margin: props.isMobile? "1vw 5vw":"1vw 20vw",
          fontSize: props.isMobile? "7.5vw":"2.2vw",
          fontWeight: "bold",
          top: "40vh",
          fontFamily: "atlas",
      }}>
      'Waiting to happen' - the cascading failures that helped ISIS escape a US-backed prison
      </div>
    </div>
    <div className="date">
      <div
      style = {{
          margin: props.isMobile? "1vw 5vw":"1vw 20vw",
          fontSize: props.isMobile? "5vw":"1.3vw",
          fontStyle: "italic",
          fontFamily: "atlas",
      }}>
      January 23, 2023
      </div>
    </div>
    <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div> 
    </div>   
  );
}